<!--
  Created by Caroline on 2019/12/12 0012.
-->
<template>
  <div class="toast">
    <div class="content" :class="toast.show ? '' : ''">
      {{toast.content}}
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  
  export default {
    name: "toast",
    props: {
    
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['toast', ]),
  
    },
    watch: {
      toast (val) {
        if(val){
          clearTimeout(timeout)
          let timeout = setTimeout(() => {
            this.hideToast()
            clearTimeout(timeout)
          }, 2000)
        }
      },
    },
    created() {
    
    },
    methods: {
      // ...mapActions(['hideToast', ]),
    }
  }
</script>

<style scoped lang="less">
  .toast {
    position: fixed;
    bottom: 5%;
    left: 50%;
    margin-left: -140px;
  
    width: 280px;
    height: 50px;
    border-radius: 4px;
    background-color: #bbbbbb6e;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    font-size: 14px;
    line-height: 50px;
    text-align: center;
    color: #6f6f6f;
  }
  
  .content {
  
  }
</style>



// WEBPACK FOOTER //
// src/components/toast.vue